import {
    Button,
    Checkbox,
    Field,
    FieldProps,
    Input,
    Radio,
    RadioGroup,
    Spinner,
} from "@fluentui/react-components";
import {Column, Row} from "../../common/Layout";
import {RouteContext} from "../../../RouteContext";
import {useNavigate, useParams} from "react-router-dom";
import {
    InputStringStatePair,
    StatePair,
    useError,
    useInputString,
    useStatePair,
    useUndefined
} from "../../../../type/States";
import {Styles} from "../../common/Styles";
import {DataTransferObjectValidation, Types} from "../../../../type/Types";
import React, {useEffect, useState} from "react";
import {visibilityName} from "../../../../constant/Visibility";
import {ShoppingPathDataTransferObject} from "../../../../model/dto/content/ShoppingPathDataTransferObject";
import {ShoppingPathValueObject} from "../../../../model/vo/content/ShoppingPathValueObject";
import {ShoppingPathIO} from "../../../../io/content/ShoppingPathIO";
import {BitMask, isVisible} from "../../../../utils/bitmask";
import {shoppingPathTypeNames} from "../../../../constant/ShoppingPathType";


export default function Edit(props: RouteContext) {
    const params = useParams<{ id: string }>()
    const itemState = useUndefined<ShoppingPathValueObject>()
    const itemErrorState = useError()

    useEffect(() => {
        if (params.id === undefined) {
            return
        }
        if (itemState.value !== undefined) {
            return
        }

        ShoppingPathIO.get(BigInt(params.id))
            .then(itemState.setDefinedValue)
            .catch(itemErrorState.setDefinedValue)
    }, [params.id, itemState.value])

    const item = itemState.value
    return <>
        <itemErrorState.Dialog {...props} />
        {item === undefined && <Spinner />}
        {item !== undefined && <>
            <EditPage
                {...props}
                item={item}></EditPage>
        </>}
    </>
}

type EditPageProps = RouteContext & {
    item: ShoppingPathValueObject
}

function EditPage(props: EditPageProps) {
    const params = useParams<{ id: string }>()
    const itemState = useUndefined<ShoppingPathValueObject>()
    const itemErrorState = useError()
    const navigate = useNavigate();

    const [previewUrl, setPreviewUrl] = useState<string[]>([])

    useEffect(() => {
        if (params.id === undefined) {
            return
        }
        if (itemState.value !== undefined) {
            return
        }

        ShoppingPathIO.get(BigInt(params.id))
            .then(itemState.setDefinedValue)
            .catch(itemErrorState.setDefinedValue)
    }, [params.id, itemState.value])

    const handlebitMaskValueChange = (index: number, value: string) => {
        const currentValue = Number(value);
        const nextValue = BitMask.invert(currentValue, index);
        return nextValue.toString();
    };

    const styles = Styles.useEditorStyles()
    const inputStates: Record<keyof ShoppingPathDataTransferObject.Put, InputStringStatePair> = {
        wishState: useInputString(props.item.isActive.toString()),
        name: useInputString(Types.present(props.item.name, '')),
        format: useInputString(Types.present(props.item.format, '')),
        visibility: useInputString(Types.present(props.item.visibility, '')),
        type: useInputString(Types.present(props.item.type, '')),
        weight: useInputString(Types.present(props.item.weight, '')),
        minValue: useInputString(Types.present(props.item.minValue, '')),
        maxValue: useInputString(Types.present(props.item.maxValue, '')),
        minLocalDate: useInputString(Types.present(props.item.minLocalDate, '')),
        maxLocalDate: useInputString(Types.present(props.item.maxLocalDate, '')),
    }
    const inputValidationStates: Record<keyof ShoppingPathDataTransferObject.Put, StatePair<FieldProps['validationState']>> = {
        wishState: useStatePair<FieldProps['validationState']>('none'),
        name: useStatePair<FieldProps['validationState']>('none'),
        format: useStatePair<FieldProps['validationState']>('none'),
        visibility: useStatePair<FieldProps['validationState']>('none'),
        type: useStatePair<FieldProps['validationState']>('none'),
        weight: useStatePair<FieldProps['validationState']>('none'),
        minValue: useStatePair<FieldProps['validationState']>('none'),
        maxValue: useStatePair<FieldProps['validationState']>('none'),
        minLocalDate: useStatePair<FieldProps['validationState']>('none'),
        maxLocalDate: useStatePair<FieldProps['validationState']>('none'),
    }
    const putErrorState = useError()

    const onDoneClick = () => {
        inputValidationStates.wishState.setValue('none')
        inputValidationStates.name.setValue('none')
        inputValidationStates.format.setValue('none')
        inputValidationStates.visibility.setValue('none')
        inputValidationStates.type.setValue('none')
        inputValidationStates.weight.setValue('none')
        inputValidationStates.minValue.setValue('none')
        inputValidationStates.maxValue.setValue('none')
        inputValidationStates.minLocalDate.setValue('none')
        inputValidationStates.maxLocalDate.setValue('none')
        try {
            const dto: ShoppingPathDataTransferObject.Put = {
                wishState: DataTransferObjectValidation.validate(ShoppingPathDataTransferObject.Put.validation, 'wishState', inputStates.wishState.value, () => inputValidationStates.wishState.setValue('error')),
                name: DataTransferObjectValidation.validate(ShoppingPathDataTransferObject.Put.validation, 'name', inputStates.name.value, () => inputValidationStates.name.setValue('error')),
                format: DataTransferObjectValidation.validate(ShoppingPathDataTransferObject.Put.validation, 'format', inputStates.format.value, () => inputValidationStates.format.setValue('error')),
                visibility: DataTransferObjectValidation.validate(ShoppingPathDataTransferObject.Put.validation, 'visibility', inputStates.visibility.value, () => inputValidationStates.visibility.setValue('error')),
                type: DataTransferObjectValidation.validate(ShoppingPathDataTransferObject.Put.validation, 'type', inputStates.type.value, () => inputValidationStates.type.setValue('error')),
                weight: DataTransferObjectValidation.validate(ShoppingPathDataTransferObject.Put.validation, 'weight', inputStates.weight.value, () => inputValidationStates.weight.setValue('error')),
                minValue: DataTransferObjectValidation.validate(ShoppingPathDataTransferObject.Put.validation, 'minValue', inputStates.minValue.value, () => inputValidationStates.minValue.setValue('error')),
                maxValue: DataTransferObjectValidation.validate(ShoppingPathDataTransferObject.Put.validation, 'maxValue', inputStates.maxValue.value, () => inputValidationStates.maxValue.setValue('error')),
                minLocalDate: DataTransferObjectValidation.validate(ShoppingPathDataTransferObject.Put.validation, 'minLocalDate', inputStates.minLocalDate.value, () => inputValidationStates.minLocalDate.setValue('error')),
                maxLocalDate: DataTransferObjectValidation.validate(ShoppingPathDataTransferObject.Put.validation, 'maxLocalDate', inputStates.maxLocalDate.value, () => inputValidationStates.maxLocalDate.setValue('error')),
            }

            ShoppingPathIO.put(props.item.id, dto)
                .then((value: any)=>{
                    window.alert('수정되었습니다.')
                })
                .catch(putErrorState.setDefinedValue)

        } catch (error) {
            console.error(error)
        }
    }

    return <>
        <putErrorState.Dialog {...props} />
        <Column gap={'16px'}>
            <Field
                className={styles.field}
                label={ShoppingPathDataTransferObject.Put.description.wishState}
                validationState={inputValidationStates.wishState.value}>
                <RadioGroup
                    value={inputStates.wishState.value}
                    onChange={
                        (_, data) => {inputStates.wishState.setValue(data.value); console.log(inputStates.wishState.value)}
                    }>
                    <Radio value="true" label="활성화" />
                    <Radio value="false" label="비활성화" />
                </RadioGroup>
            </Field>
            <Field
                className={styles.field}
                label={ShoppingPathDataTransferObject.Put.description.visibility}
                validationState={inputValidationStates.visibility.value}>
                <>
                    <Checkbox
                        checked={Number(inputStates.visibility.value) == Math.pow(2, visibilityName.length) - 1}
                        onChange={() => {
                            if (Number(inputStates.visibility.value) == Math.pow(2, visibilityName.length)-1) {
                                inputStates.visibility.setValue('0')
                            }
                            else{
                                inputStates.visibility.setValue((Math.pow(2,visibilityName.length)-1).toString())
                            }
                        }}
                        label="전체선택"
                    />
                    {
                        visibilityName.map((v, idx) => (
                            <Checkbox
                                key={idx}
                                checked={isVisible(Number(inputStates.visibility.value),idx)}
                                onChange={() => inputStates.visibility.setValue(handlebitMaskValueChange(idx,inputStates.visibility.value))}
                                label={v}
                            />
                        ))
                    }
                </>
            </Field>
            <Field
                className={styles.field}
                label={ShoppingPathDataTransferObject.Put.description.type}
                validationState={inputValidationStates.type.value}>
                {
                    shoppingPathTypeNames.map((v, idx) => (
                        <Checkbox
                            key={idx}
                            checked={isVisible(Number(inputStates.type.value), idx)}
                            onChange={() => inputStates.type.setValue(handlebitMaskValueChange(idx,inputStates.type.value))}
                            label={v} />
                    ))
                }
            </Field>
            <Field
                className={styles.field}
                label={ShoppingPathDataTransferObject.Put.description.name}
                validationState={inputValidationStates.name.value}>
                <Input
                    value={inputStates.name.value}
                    onChange={inputStates.name.onChange} />
            </Field>
            <Field
                className={styles.field}
                label={ShoppingPathDataTransferObject.Put.description.format}
                validationState={inputValidationStates.format.value}>
                <Input
                    value={inputStates.format.value}
                    onChange={inputStates.format.onChange} />
            </Field>
            <Field
                className={styles.field}
                label={ShoppingPathDataTransferObject.Put.description.weight}
                validationState={inputValidationStates.weight.value}>
                <Input
                    value={inputStates.weight.value}
                    onChange={inputStates.weight.onChange} />
            </Field>
            <Field
                className={styles.field}
                label={ShoppingPathDataTransferObject.Put.description.minValue}
                validationState={inputValidationStates.minValue.value}>
                <Input
                    value={inputStates.minValue.value}
                    onChange={inputStates.minValue.onChange} />
            </Field>
            <Field
                className={styles.field}
                label={ShoppingPathDataTransferObject.Put.description.maxValue}
                validationState={inputValidationStates.maxValue.value}>
                <Input
                    value={inputStates.maxValue.value}
                    onChange={inputStates.maxValue.onChange} />
            </Field>
            <Field
                className={styles.field}
                label={ShoppingPathDataTransferObject.Put.description.minLocalDate}
                validationState={inputValidationStates.minLocalDate.value}>
                <Input
                    value={inputStates.minLocalDate.value}
                    onChange={inputStates.minLocalDate.onChange} />
            </Field>
            <Field
                className={styles.field}
                label={ShoppingPathDataTransferObject.Put.description.maxLocalDate}
                validationState={inputValidationStates.maxLocalDate.value}>
                <Input
                    value={inputStates.maxLocalDate.value}
                    onChange={inputStates.maxLocalDate.onChange} />
            </Field>
            <Row>
                <Button
                    appearance={'primary'}
                    onClick={onDoneClick}>
                    완료
                </Button>
            </Row>
        </Column>
    </>
}